import PropTypes from "prop-types";

export const ACTIONS = {
  BOOK: "book",
  ENQUIRY_MESSAGE: "enquiry",
  FAST_TRACK_INFORMATION: "fast-track-information",
  NONE: "",
};

export const SUPPORTED_TRANSLATION_LANGUAGES = ["es", "en"];

export const SECTION_TYPE_TEXT_PROPS = PropTypes.shape({
  title: PropTypes.string,
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      elements: PropTypes.arrayOf(
        PropTypes.shape({ content: PropTypes.string }),
      ),
    }),
  ),
});

export const SECTION_TYPE_ICON_PROPS = PropTypes.shape({
  title: PropTypes.string,
  elements: PropTypes.arrayOf(
    PropTypes.shape({ icon: PropTypes.string, content: PropTypes.string }),
  ),
});
